import { useEffect } from 'react'

const useDismiss = (ref, open, onDismiss) => {
    useEffect(() => {
        if (!open) return undefined
        const onPointerDown = (event) => {
            if (!ref.current?.contains(event.target)) onDismiss()
        }
        const onKeyDown = (event) => {
            if (event.key === 'Escape') onDismiss()
        }
        document.addEventListener('mousedown', onPointerDown)
        document.addEventListener('keydown', onKeyDown)
        return () => {
            document.removeEventListener('mousedown', onPointerDown)
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [ref, open, onDismiss])
}

export default useDismiss
